[
    {
        "question": "Why Marine Insurance?",
        "is_answer_multiple": false,
        "is_answer_header": false,
        "answer": [
            " Marine  Cargo  insurance  is  to  limit  your risk  exposure  to  financial  loss  due  to  damage/  loss of goods during marine transit. Shipping goods via Sea, Rail, Road or Air is risky. Goods may be damaged or completely lost while on their way to you or your customer."
        ]
    },
    {
        "question": "What does Marine Insurance cover?",
        "is_answer_multiple": false,
        "is_answer_header": false,
        "answer": [
            "Marine insurance covers :1. Fire or blast, sinking, stranding etc. 2. Collision, the overturning of land transport 3. The release of cargo at the port of disturbance 4. Average sacrifice recovery charges 5. Washing overboard 6. Earthquake or lightning 7. Total loss of package lost overboard"
        ]
    },
    {
        "question": "What are the things not covered by Marine Insurance?",
        "is_answer_multiple": true,
        "is_answer_header": true,
        "answer_header": [
            "following are the exclusions under the Marine Insurance"
        ],
        "answer": [
            "Wilful Misconduct of the assured",
            "Ordinary leakage / Ordinary leakage / Loss of weight or volume",
            "Inadequate Packing / lashing / stacking / stowage of cargo",
            "Inherent vice / Nature of the cargo",
            "Loss arising out of delay",
            "Loss or damage due to any financial default or insolvency of the ship-owner etc.",
            "Nuclear or Radioactive force or matter",
            "War / SRCC"
        ]
    },
    {
        "question": "Who can buy Marine Insurance? ",
        "is_answer_multiple": false,
        "is_answer_header": false,
        "answer": [
            " Those who own a cargo with an insurable interest, like Buyers, Sellers, Import/Export merchants, Manufacturer, Traders, Buying Agents, Contractors of projects etc."
        ]
    },
    {
        "question": "What are the types of sales contract under Marine insurance",
        "is_answer_multiple": false,
        "is_answer_header": false,
        "answer": [
            "The types of contract under marine insurance are: 1. FOB Contract- Free on Board 2. FOR Contract- free on Rail 3. C&F Contract- Cost &Freight 4. CIF Contract- Cost, Insurance & Freight. 5.EXW : Ex works 6. DAP - Delivered at Place"
        ]
    },
    {
        "question": "What does “CIF+10%” mean?",
        "is_answer_multiple": true,
        "is_answer_header": true,
        "answer_header": [
            " CIF+10% stands for:"
        ],
        "answer": [
            " C = Cost/invoice value (purchase cost if your client is the buyer, or selling price if they are the seller)",
            " I = Insurance premium",
            " F = Freight and associated charges (e.g. customs clearance charges)",
            " PLUS an additional 10% to cover additional charges incurred due to fluctuations in currency or additional freight cost.",
            " The intention is to indemnify your client, including allowances for additional cost for reshipping."
        ]
    },
    {
        "question": "What is the difference between inland transit insurance and ocean cargo insurance?",
        "is_answer_multiple": false,
        "is_answer_header": false,
        "answer": [
            "Inland transit insurance covers domestic transits via land conveyances and/or air shipments(domestic vessel transits are usually insured under an Ocean Cargo Policy). Ocean cargo insurance provides coverage for international ocean and/or air shipments on a warehouse to warehouse basis(including the land connecting conveyance transits)"
        ]
    },
    {
        "question": "How much Marine Cargo Insurance do I need?",
        "is_answer_multiple": true,
        "is_answer_header": true,
        "answer_header": [
            " Follow this simple two-step process to arrive at the amount of Marine Cargo Insurance you need."
        ],
        "answer": [
            " Marine cargo insurers will value goods to be shipped at the invoice cost + freight cost.",
            " Take the sum from step 1, and add an additional 10% – 20%. to account for additional expenses which may be incurred during shipment.",
            " The final amount is the coverage you will need from a Marine Cargo Insurance policy."
        ]
    },
    {
        "question": "What is a General Average?",
        "is_answer_multiple": false,
        "is_answer_header": false,
        "answer": [
            "A loss arising through a voluntary sacrifice of any part of the ship or cargo, or an expenditure to safeguard the ship and the rest of the cargo. When the vessel owner declares a general average, the vessel owner and all the cargo interests will share the expenses associated with the general average on a pro-rata basis. These expenses are covered under your Marine Cargo Insurance Policy. Such losses can be significant and may require letters of guarantee to have the cargo released. A letter of guarantee would be issued by the cargo underwriters and is an agreement to meet the insured’s liability for contribution.A loss arising through a voluntary sacrifice of any part of the ship or cargo, or an expenditure to safeguard the ship and the rest of the cargo. When the vessel owner declares a general average, the vessel owner and all the cargo interests will share the expenses associated with the general average on a pro-rata basis. These expenses are covered under your Marine Cargo Insurance Policy. Such losses can be significant and may require letters of guarantee to have the cargo released. A letter of guarantee would be issued by the cargo underwriters and is an agreement to meet the insured’s liability for contribution."
        ]
    },
    {
        "question": "What are the “Incoterms”?",
        "is_answer_multiple": false,
        "is_answer_header": false,
        "answer": [
            "Incoterms are a frame work that help define responsibilities of the buyer and the seller and are recognized as the international standard by custom authorities and courts in all the main trading nations. They are standard trade definitions and are issued by the International Chamber of Commerce. Incoterms reduce the risk of misunderstandings and legal disputes. Incoterms also specify the loading and unloading responsibilities of the buyer and seller. There are currently 11 Incoterms, each denoted by a 3-letter code. The terms are grouped in four categories based on the first letter in the three-letter abbreviation."
        ]
    },
    {
        "question": "How is the premium of marine insurance decided?",
        "is_answer_multiple": false,
        "is_answer_header": false,
        "answer": [
            "Premium rate and workings are based on host of factors not limiting to the type of cargo, packaging, mode of transit, conveyance type, type of vessel (whether bulk / general cargo etc), past claims experience, experience of proposer etc."
        ]
    },
    {
        "question": "How can I make a claim, in case of a cargo emergency?",
        "is_answer_multiple": true,
        "is_answer_header": true,
        "answer_header": [
            " In the event of loss of or damage to cargo, Assured must give immediate notice of such loss or damage to the Insurer for appointing Surveyor / Claims representative to carry out survey of the affected goods. To enable all claims to be dealt with promptly the Assured or their agents are advised to submit all documents corroborating the damages without delay including, when applicable."
        ],
        "answer": [
            "Original Policy or Certificate of Insurance.",
            "Original Invoice Copy and transport document viz. B/L, L/R, AWB, GCN etc. along with weight notes and other shipping specifications.",
            "Landing account and weight notes at final destination.",
            "Correspondence exchanged with the carriers and other parties regarding their liability for the loss or damage.",
            "The list indicated above is only indicative and facts of each claim may require the Insurer to call for additional documents supporting the claim."
        ]
    }
]